import React, {useEffect, useState} from 'react';
import { Formik, Form } from 'formik';
import { TextField } from './TextField';
import * as Yup from 'yup';
import {useHistory} from "react-router";

export const SignUp = ({isAuth,loginMe}) => {
    debugger
    let history = useHistory();
    let [isAuthed, setAuthed] =useState(isAuth);
    const validate = Yup.object({
        username: Yup.string()
            .max(25, 'Username must be max 25 charaters')
            .required('Required'),
        password: Yup.string()
            .min(4, 'Password must be at least 4 charaters')
            .required('Password is required')
    });
    useEffect(()=>{
        setAuthed(isAuth)
    },[isAuth])

    useEffect(()=>{
        if(isAuthed===true){
            history.push("/Home");
            window.location.reload();
            // history.push("/");
            // history.push("/Home");
            // // history.go(0)
            // window.location.reload();

        }
    },[isAuthed])
// debugger
    return (
            <Formik
                initialValues={{
                    username: '',
                    password: ''
                }}
                validationSchema={validate}
                onSubmit={(formValues)=> {
                    loginMe(formValues.username,formValues.password)
                }}
            >
                {props => (
                    <div>
                        <h1 className="my-4 font-weight-bold display-5 text-center">Medic School</h1>
                        <Form >
                            <TextField label="Username"
                                       name="username"
                                       type="text"
                            />
                            <TextField label="Password"
                                       name="password"
                                       type="password"
                            />
                            <div className="text-center">
                                <button className="btn btn-success mt-3" type="submit" >Login</button>
                                <button className="btn btn-danger mt-3 ml-3" type="reset">Reset</button>
                            </div>
                        </Form>
                    </div>
                )}
            </Formik>
    )
}
